import { HostingEnvironment } from "./models";
import { utils } from "./utils/index";

const DevelopmentEnv = {
    REACT_APP_TITLE: "LiveAdmins Live Chat",
    REACT_APP_TAB_TITLE: "LiveAdmins Live Chat",
    REACT_APP_NAME: "WG Live Chat",
    REACT_APP_TARGET_BUILD: "Web",
    REACT_APP_IS_TRANSLATION: false,
    REACT_APP_IS_DISABLED_SIGNUP_ROUTE: false,
    REACT_APP_IS_LOCALIZATION_ENABLE: true,
    REACT_APP_IS_FIREBASE_ENABLE: false,
    REACT_APP_API_BASE_URL: "https://dev1.thelivechatsoftware.com",
    REACT_APP_BOT_BASE_URL: "https://botdev.thelivechatsoftware.com/botgen",
    REACT_APP_HOST_URL: "https://testing.thelivechatsoftware.com",

    REACT_APP_LOGO: "login-page-la.svg",
    REACT_APP_NOTIFICATION_LOGO: "notification-la.png",
    REACT_APP_HELP_IMAGE: "allow-notification-help-la.png",
    REACT_APP_FAVICONE: "favicon-la.ico",
    REACT_APP_HELP_IMAGE_FOR_SAFARI: "allow-notification-for-safari.png",

    REACT_APP_MANIFEST_CONFIGURATION: "LA-manifest-config.json",
    REACT_APP_STYLESHEET: "GlobalStyleLa.css",
    REACT_APP_DARKMODE_STYLESHEET: "DarkGlobalStyleLA.css",
    REACT_APP_BG_IMAGE_STYLE: "la-login-bg",
    REACT_APP_MOBILE_LOGO: "logo-mobile.svg",

    REACT_APP_COPYRIGHT: "LiveAdmins. All rights reserved.",
    REACT_APP_PRIVACY_POLICY: "https://www.liveadmins.com/privacy-policy/",
    REACT_APP_GRAMMARLY_CLIENT_ID: "client_5yfFfETBf26eeywGHGWiuF",
    REACT_FIREBASE_SITE_KEY: "6LesBBspAAAAAGL7fi0U_-SY9DPHwuvBdw-D2bUk",
    VAPID_KEY: "",
    REACT_APP_FIREBASE_CONFIG: {
        apiKey: "AIzaSyDg_9w7A5A8JuqK7E9v-ilwfHaw-2CEjmo",
        authDomain: "uat-operator-panel.firebaseapp.com",
        projectId: "uat-operator-panel",
        storageBucket: "uat-operator-panel.appspot.com",
        messagingSenderId: "174734694333",
        appId: "1:174734694333:web:d5105b229e0cc67cc764d4",
        measurementId: "G-JB7ZL27M7Q",
    },
};

const DevelopmentEnvDev1 = {
    REACT_APP_TITLE: "LiveAdmins Live Chat",
    REACT_APP_TAB_TITLE: "LiveAdmins Live Chat",
    REACT_APP_NAME: "WG Live Chat",
    REACT_APP_TARGET_BUILD: "Web",
    REACT_APP_IS_TRANSLATION: false,
    REACT_APP_IS_DISABLED_SIGNUP_ROUTE: false,
    REACT_APP_IS_LOCALIZATION_ENABLE: true,
    REACT_APP_IS_FIREBASE_ENABLE: false,
    REACT_APP_API_BASE_URL: "https://dev1.thelivechatsoftware.com",
    REACT_APP_BOT_BASE_URL: "https://botdev.thelivechatsoftware.com/botgen",
    REACT_APP_HOST_URL: "https://dev1.thelivechatsoftware.com/",

    REACT_APP_LOGO: "login-page-la.svg",
    REACT_APP_NOTIFICATION_LOGO: "notification-la.png",
    REACT_APP_HELP_IMAGE: "allow-notification-help-la.png",
    REACT_APP_FAVICONE: "favicon-la.ico",
    REACT_APP_HELP_IMAGE_FOR_SAFARI: "allow-notification-for-safari.png",

    REACT_APP_MANIFEST_CONFIGURATION: "LA-manifest-config.json",
    REACT_APP_STYLESHEET: "GlobalStyleLa.css",
    REACT_APP_DARKMODE_STYLESHEET: "DarkGlobalStyleLA.css",
    REACT_APP_BG_IMAGE_STYLE: "la-login-bg",
    REACT_APP_MOBILE_LOGO: "logo-mobile.svg",

    REACT_APP_COPYRIGHT: "LiveAdmins. All rights reserved.",
    REACT_APP_PRIVACY_POLICY: "https://www.liveadmins.com/privacy-policy/",
    REACT_APP_GRAMMARLY_CLIENT_ID: "client_5yfFfETBf26eeywGHGWiuF",
    REACT_FIREBASE_SITE_KEY: "6LesBBspAAAAAGL7fi0U_-SY9DPHwuvBdw-D2bUk",
    VAPID_KEY: "",
    REACT_APP_FIREBASE_CONFIG: {
        apiKey: "AIzaSyDg_9w7A5A8JuqK7E9v-ilwfHaw-2CEjmo",
        authDomain: "uat-operator-panel.firebaseapp.com",
        projectId: "uat-operator-panel",
        storageBucket: "uat-operator-panel.appspot.com",
        messagingSenderId: "174734694333",
        appId: "1:174734694333:web:d5105b229e0cc67cc764d4",
        measurementId: "G-JB7ZL27M7Q",
    },
};

const LiveAdminConfig = {
    REACT_APP_TITLE: "LiveAdmins Live Chat",
    REACT_APP_TAB_TITLE: "LiveAdmins Live Chat",
    REACT_APP_NAME: "WG Live Chat",
    REACT_APP_TARGET_BUILD: "Web",
    REACT_APP_IS_TRANSLATION: false,
    REACT_APP_IS_DISABLED_SIGNUP_ROUTE: false,
    REACT_APP_IS_LOCALIZATION_ENABLE: true,
    REACT_APP_IS_FIREBASE_ENABLE: true,
    REACT_APP_API_BASE_URL: "https://blue.thelivechatsoftware.com",
    REACT_APP_BOT_BASE_URL: "https://chatbot.thelivechatsoftware.com/botgen",
    REACT_APP_HOST_URL: "https://web.liveadmins.net",

    REACT_APP_LOGO: "login-page-la.svg",
    REACT_APP_NOTIFICATION_LOGO: "notification-la.png",
    REACT_APP_HELP_IMAGE: "allow-notofication-image-la.png",
    REACT_APP_FAVICONE: "favicon-la.ico",
    REACT_APP_HELP_IMAGE_FOR_SAFARI: "allow-notification-for-safari.png",

    REACT_APP_MANIFEST_CONFIGURATION: "LA-manifest-config.json",
    REACT_APP_STYLESHEET: "GlobalStyleLa.css",
    REACT_APP_DARKMODE_STYLESHEET: "DarkGlobalStyleLA.css",
    REACT_APP_BG_IMAGE_STYLE: "la-login-bg",
    REACT_APP_MOBILE_LOGO: "logo-mobile.svg",
    REACT_APP_COPYRIGHT: "LiveAdmins. All rights reserved.",
    REACT_APP_PRIVACY_POLICY: "https://www.liveadmins.com/privacy-policy/",

    REACT_APP_GRAMMARLY_CLIENT_ID: "client_5yfFfETBf26eeywGHGWiuF",
    REACT_FIREBASE_SITE_KEY: "6LfigxIpAAAAAPIEQ5RdkizdHQPG9FKiKt_hb_AO",
    VAPID_KEY: "BHnEvOHAlQBaI7h4RFliplvrvSMJ_TZtvRgZM99jx7i6hBmk7Ovv7xSZVDwFpAPl1UavfNod_94QCMQXfXK7Qac",
    REACT_APP_FIREBASE_CONFIG: {
        apiKey: "AIzaSyAmur8KPX7NJWFfdDSxhfaUhox0FiGkbgk",
        authDomain: "operatorportal-c13c1.firebaseapp.com",
        projectId: "operatorportal-c13c1",
        storageBucket: "operatorportal-c13c1.appspot.com",
        messagingSenderId: "447143726372",
        appId: "1:447143726372:web:1135cb835f118447a877b1",
        measurementId: "G-MJYT9V8EK4",
    },
};

const ElectronConfig = {
    REACT_APP_TITLE: "LiveAdmins Live Chat",
    REACT_APP_TAB_TITLE: "LiveAdmins Live Chat",
    REACT_APP_NAME: "WG Live Chat",
    REACT_APP_TARGET_BUILD: "electron",
    REACT_APP_API_BASE_URL: "https://blue.thelivechatsoftware.com",
    REACT_APP_BOT_BASE_URL: "https://botdev.thelivechatsoftware.com/botgen",
    REACT_APP_HOST_URL: "https://web.liveadmins.net",
    REACT_APP_IS_TRANSLATION: false,
    REACT_APP_IS_DISABLED_SIGNUP_ROUTE: false,
    REACT_APP_IS_LOCALIZATION_ENABLE: true,
    REACT_APP_IS_FIREBASE_ENABLE: false,
    REACT_APP_LOGO: "login-page-la.svg",
    REACT_APP_NOTIFICATION_LOGO: "notification-la.png",
    REACT_APP_HELP_IMAGE: "allow-notofication-image-la.png",
    REACT_APP_FAVICONE: "favicon-la.ico",
    REACT_APP_HELP_IMAGE_FOR_SAFARI: "allow-notification-for-safari.png",
    REACT_APP_MOBILE_LOGO: "logo-mobile.svg",
    REACT_APP_MANIFEST_CONFIGURATION: "LA-manifest-config.json",
    REACT_APP_STYLESHEET: "GlobalStyleLa.css",
    REACT_APP_DARKMODE_STYLESHEET: "DarkGlobalStyleLA.css",
    REACT_APP_BG_IMAGE_STYLE: "la-login-bg",

    REACT_APP_COPYRIGHT: "LiveAdmins. All rights reserved.",
    REACT_APP_PRIVACY_POLICY: "https://www.liveadmins.com/privacy-policy/",

    REACT_APP_GRAMMARLY_CLIENT_ID: "client_5yfFfETBf26eeywGHGWiuF",
    REACT_FIREBASE_SITE_KEY: "",
    VAPID_KEY: "",
    REACT_APP_FIREBASE_CONFIG: {
        apiKey: "",
        authDomain: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: "",
        measurementId: "",
    },
};

const DEPConfig = {
    REACT_APP_TITLE: "Dealer eProcess Live Chat",
    REACT_APP_TAB_TITLE: "DEP Live Chat",
    REACT_APP_NAME: "DEP Live Chat",
    REACT_APP_TARGET_BUILD: "Web",
    REACT_APP_IS_TRANSLATION: false,
    REACT_APP_IS_DISABLED_SIGNUP_ROUTE: true,
    REACT_APP_IS_LOCALIZATION_ENABLE: false,
    REACT_APP_IS_FIREBASE_ENABLE: true,
    REACT_APP_API_BASE_URL: "https://alpha.dealereprocesschat.com",
    REACT_APP_BOT_BASE_URL: "",
    REACT_APP_HOST_URL: "https://dashboard.dealereprocesschat.com",

    REACT_APP_LOGO: "login-page-dep.png",
    REACT_APP_NOTIFICATION_LOGO: "notification-dep.png",
    REACT_APP_HELP_IMAGE: "allow-notification-dep.png",
    REACT_APP_HELP_IMAGE_FOR_SAFARI: "dealereprocess_notification_safari.png",
    REACT_APP_FAVICONE: "favicon-dep.ico",
    REACT_APP_MOBILE_LOGO: "favicon-dep.ico",

    REACT_APP_MANIFEST_CONFIGURATION: "DEP-manifest-config.json",
    REACT_APP_STYLESHEET: "GlobalStyleDep.css",
    REACT_APP_DARKMODE_STYLESHEET: "DarkGlobalStyleDep.css",
    REACT_APP_BG_IMAGE_STYLE: "login-bg",

    REACT_APP_COPYRIGHT: "Dealer eProcess. All Rights Reserved.",
    REACT_APP_PRIVACY_POLICY: "https://www.dealereprocess.com/privacy-policy/",

    REACT_APP_GRAMMARLY_CLIENT_ID: "client_FT3MFYB65SBWZcdvzt9Dfk",

    REACT_FIREBASE_SITE_KEY: "6Ldp_BopAAAAAFq_yp2_e-d_mhyDSX1SdG9FQnr-",
    VAPID_KEY: "BGRiv-iGADSGAx0Jpt19DA9fkZh1uZv4YlPUy_iGSQRoWtJFp3dtHzmRHtDtNNPAkHTTEhyvkHNZ-e4wi171ZcA",
    REACT_APP_FIREBASE_CONFIG: {
        apiKey: "AIzaSyCzIcAXjOEBDmg3A9O8snUEGTuE2p9g1fA",
        authDomain: "dep-operator-panel.firebaseapp.com",
        projectId: "dep-operator-panel",
        storageBucket: "dep-operator-panel.appspot.com",
        messagingSenderId: "675306285472",
        appId: "1:675306285472:web:d53c2c3cb5042c72db1cc5",
        measurementId: "G-JD8B1DLHHH",
    },
};

const SmartMarkeetingConfig = {
    REACT_APP_TITLE: "i1SmartMarketing SmartChat Dashboard",
    REACT_APP_TAB_TITLE: "i1SmartMarketing",
    REACT_APP_NAME: "smartmarketing",
    REACT_APP_API_BASE_URL: "https://smartchat.i1smartmarketing.com",
    REACT_APP_BOT_BASE_URL: "",
    REACT_APP_HOST_URL: "https://smartchat.i1smartmarketing.com",
    REACT_APP_TARGET_BUILD: "Web",
    REACT_APP_IS_TRANSLATION: false,
    REACT_APP_IS_LOCALIZATION_ENABLE: true,
    REACT_APP_IS_DISABLED_SIGNUP_ROUTE: true,
    REACT_APP_IS_FIREBASE_ENABLE: true,
    REACT_APP_LOGO: "notification-iSmart.png",
    REACT_APP_NOTIFICATION_LOGO: "android-chrome-192.png",
    REACT_APP_HELP_IMAGE_FOR_SAFARI: "ismartmarketing_notification_safari.png",
    REACT_APP_FAVICONE: "favicon.ico",
    REACT_APP_HELP_IMAGE: "i1smartmarkeeting-notification-help.png",
    REACT_APP_MANIFEST_CONFIGURATION: "iSmartMarkeeting-manifest-config.json",
    REACT_APP_STYLESHEET: "GlobalStyleLa.css",
    REACT_APP_DARKMODE_STYLESHEET: "DarkGlobalStyleLA.css",
    REACT_APP_BG_IMAGE_STYLE: "login-bg-i1SmartMarkeeting",
    REACT_APP_MOBILE_LOGO: "login-page-iSmart.png",

    REACT_APP_COPYRIGHT: "i1smartmarketing. All rights reserved.",
    REACT_APP_PRIVACY_POLICY: "",

    REACT_APP_GRAMMARLY_CLIENT_ID: "",
    REACT_FIREBASE_SITE_KEY: "6Lf-RhspAAAAACbovIjJ4do9ijPKg9oKHIOyb86S",
    VAPID_KEY: "BOlCKYWEhfgAzoTooCwfYzSdLpWaKRvCkxopwosKP3td2b-daaoWSobjQTn4RSkKeemVM8hul8uYTkEXndyz3D4",
    REACT_APP_FIREBASE_CONFIG: {
        apiKey: "AIzaSyDZkPYr9izkjun1ywNTx-cMDqRYVjz57H0",
        authDomain: "i1smartmarketing.firebaseapp.com",
        projectId: "i1smartmarketing",
        storageBucket: "i1smartmarketing.appspot.com",
        messagingSenderId: "256690192045",
        appId: "1:256690192045:web:982b2beb0f9cd195fe9024",
        measurementId: "G-GX5C8NJ874",
    },
};

const InterChangesConfig = {
    REACT_APP_TITLE: "Interchanges",
    REACT_APP_TAB_TITLE: "Interchanges",
    REACT_APP_NAME: "Interchanges",
    REACT_APP_API_BASE_URL: "https://web.interchangeschat.com",
    REACT_APP_BOT_BASE_URL: "",
    REACT_APP_HOST_URL: "https://web.interchangeschat.com",
    REACT_APP_TARGET_BUILD: "Web",
    REACT_APP_IS_TRANSLATION: false,
    REACT_APP_IS_LOCALIZATION_ENABLE: false,
    REACT_APP_IS_DISABLED_SIGNUP_ROUTE: true,
    REACT_APP_IS_FIREBASE_ENABLE: false,
    REACT_APP_LOGO: "arrows.svg",
    REACT_APP_NOTIFICATION_LOGO: "arrows.svg",
    REACT_APP_HELP_IMAGE_FOR_SAFARI: "interchages_notification_safari.png",
    REACT_APP_FAVICONE: "interchange-favicon.ico",
    REACT_APP_HELP_IMAGE: "interchages_notification.png",
    REACT_APP_MANIFEST_CONFIGURATION: "",
    REACT_APP_STYLESHEET: "GlobalStyleLa.css",
    REACT_APP_DARKMODE_STYLESHEET: "DarkGlobalStyleLA.css",
    REACT_APP_BG_IMAGE_STYLE: "login-bg-interchanges",
    REACT_APP_MOBILE_LOGO: "arrows.svg",

    REACT_APP_COPYRIGHT: "Interchanges. All rights reserved.",
    REACT_APP_PRIVACY_POLICY: "",

    REACT_APP_GRAMMARLY_CLIENT_ID: "",
    REACT_FIREBASE_SITE_KEY: "",
    VAPID_KEY: "",
    REACT_APP_FIREBASE_CONFIG: {
        apiKey: "",
        authDomain: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: "",
        measurementId: "",
    },
};

class detectEnvironment {
    private selectedEnvironment: any = DevelopmentEnv;
    constructor() {
        this.Setup();
    }

    async Setup() {
        try {
            const domain = window.location.hostname;
            var selectedHost = DevelopmentEnv;

            if (domain.includes("testing.thelivechatsoftware.com")) {
                selectedHost = DevelopmentEnv;
            } else if (domain.includes("dev1.thelivechatsoftware.com")) {
                selectedHost = DevelopmentEnvDev1;
            }else if (domain.includes("smartchat.i1smartmarketing.com")) {
                selectedHost = SmartMarkeetingConfig;
            } else if (domain.includes("dealereprocess")) {
                selectedHost = DEPConfig;
            } else if (domain.includes("web.liveadmins.net")) {
                selectedHost = LiveAdminConfig;
            } else if (domain.includes("web.interchangeschat.com")) {
                selectedHost = InterChangesConfig;
            }
            else if (domain == "") {
                selectedHost = ElectronConfig;
            }

            this.selectedEnvironment = selectedHost;
        } catch (ex) { }
    }

    public get config() {
        return this.selectedEnvironment;
    }
}

var DetectEnvironment = new detectEnvironment();
export { DetectEnvironment };
